import { CommitmentSetupTabProps } from "features/commitments/setup/CommitmentSetupTabProps";
import BasicTableTab from "features/commitments/tabs/BasicTableTab";
import { useCommitmentInformationTableDataByFundRetrieveSuspense } from "gen/endpoints/commitment-information-table-data-by-fund/commitment-information-table-data-by-fund";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { GetLinkInfoForRowFn } from "shared/components/table/data/DataTableTypes";
import { rootRoute } from "shared/navigation/Routes";
import invariant from "shared/utils/TinyInvariant";

export const InvestorEntityTabCommitments: React.FC = () => {
  const { t } = useTranslation(["investorEntity", "common"]);

  const { investorEntityId } = useOutletContext<CommitmentSetupTabProps>();
  invariant(investorEntityId);

  const { data: tableData } =
    useCommitmentInformationTableDataByFundRetrieveSuspense({
      investor_entity_id: investorEntityId,
    });

  const getLinkInfoForRow = useCallback<GetLinkInfoForRowFn>(
    ({ row }) => {
      const metadata = row.data?.metadata;
      if (metadata?.type !== "id_row") {
        return undefined;
      }
      return row.data?.granularity_level === "investor_entity"
        ? {
            type: "generic",
            to: rootRoute({})
              .investorEntities({})
              .investorEntity({ investorEntityId: metadata.id })
              .tabActivity({}).$,
          }
        : row.data?.granularity_level === "security_ownership" &&
            row.data.cells["fund_family_id"].value?.type === "text" &&
            row.data.cells["fund_family_id"].value.text
          ? {
              type: "generic",
              to: rootRoute({})
                .fundFamilies({})
                .fundFamily({
                  fundFamilyId: row.data.cells["fund_family_id"].value.text,
                })
                .commitments({})
                .investorEntities({})
                .investorEntityCommitments({ investorEntityId })
                .commitment({ commitmentId: metadata.id })
                .activity({}).$,
            }
          : undefined;
    },
    [investorEntityId],
  );

  return (
    <BasicTableTab
      tableTitle={t("investorEntity:tabs.commitments.table.title")}
      emptyStateProps={{
        title: t("investorEntity:tabs.commitments.table.empty.title"),
        description: t(
          "investorEntity:tabs.commitments.table.empty.description",
        ),
      }}
      data={tableData}
      getLinkInfoForRow={getLinkInfoForRow}
    />
  );
};
